export default __webpack_public_path__ + "static/media/Eb4.3bf8e70b.mp3";